import * as React from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import { getPrefixCls } from '../configure';
import Element from './Element';
// eslint-disable-next-line react/prefer-stateless-function
class SkeletonAvatar extends React.Component {
    constructor() {
        super(...arguments);
        this.renderSkeletonAvatar = () => {
            const { prefixCls: customizePrefixCls, className, active } = this.props;
            const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
            const otherProps = omit(this.props, ['prefixCls']);
            const cls = classNames(prefixCls, className, `${prefixCls}-element`, {
                [`${prefixCls}-active`]: active,
            });
            return (React.createElement("div", { className: cls },
                React.createElement(Element, Object.assign({ prefixCls: `${prefixCls}-avatar` }, otherProps))));
        };
    }
    render() {
        return React.createElement(React.Fragment, null, this.renderSkeletonAvatar());
    }
}
SkeletonAvatar.defaultProps = {
    size: 'default',
    shape: 'circle',
};
export default SkeletonAvatar;
